import Request from './request-service';

const DOCUMENT_IMAGE_KEY_PATTERN = /^[a-z0-9-]+\/document-images\/[a-z0-9-_]+\/[^/?#]+$/i;

const normalizeDocumentImageKeyCandidate = (value: string | null | undefined): string | null => {
  const trimmed = value?.trim().replace(/^\/+/, '') ?? '';
  return DOCUMENT_IMAGE_KEY_PATTERN.test(trimmed) ? trimmed : null;
};

export const getDocumentImageKey = (value: string | null | undefined): string | null => {
  if (!value) return null;
  const trimmed = value.trim();
  if (!trimmed) return null;

  const directKey = normalizeDocumentImageKeyCandidate(trimmed);
  if (directKey) return directKey;

  try {
    const url = new URL(trimmed, 'https://assistiv.local');
    const queryKey = normalizeDocumentImageKeyCandidate(url.searchParams.get('key'));
    if (queryKey) return queryKey;

    const pathParts = url.pathname.split('/').filter(Boolean);
    const documentImagesIndex = pathParts.findIndex((part) => part === 'document-images');
    if (documentImagesIndex <= 0 || documentImagesIndex + 2 >= pathParts.length) return null;

    return normalizeDocumentImageKeyCandidate(
      pathParts
        .slice(documentImagesIndex - 1)
        .map((part) => decodeURIComponent(part))
        .join('/'),
    );
  } catch {
    return null;
  }
};

export const isDocumentImageKey = (value: string | null | undefined): value is string => {
  return getDocumentImageKey(value) !== null;
};

export const getDocumentImageProxyEndpoint = (key: string, retryNonce = 0): string => {
  const params = new URLSearchParams({ key });
  if (retryNonce) {
    params.set('v', String(retryNonce));
  }

  return `content/document/image/view?${params.toString()}`;
};

export const getDocumentImageProxyUrl = (key: string, retryNonce = 0): string =>
  Request.buildUrl(getDocumentImageProxyEndpoint(key, retryNonce));
